import { UMFormGroup, UMInput } from '../../urbanmap/_components';
import { fmt } from './domain';
import { PC, UMR, caption } from './tokens';

/** Les degrés-jours s'affichent sans unité : ce sont des nombres de référence. */
function Figure({ label, value, highlight }: { label: string; value: number; highlight?: boolean }) {
  return (
    <span style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
      <span style={{ ...caption, fontWeight: 700 }}>{label}</span>
      <span style={{ fontSize: 20, lineHeight: '26px', fontWeight: 700, fontVariantNumeric: 'tabular-nums', color: highlight ? PC.accentStrong : UMR.black }}>
        {fmt(value)}
      </span>
    </span>
  );
}

/** Couple DJU / DJClim en lecture, groupé pour ne pas sembler lié aux tableaux voisins. */
export function DegreePair({ dju, djclim, hint, highlight }: {
  dju: number; djclim: number; hint: string; highlight?: boolean;
}) {
  return (
    <div style={{ display: 'inline-flex', flexDirection: 'column', gap: 2, padding: '6px 12px', background: UMR.grey100, border: `1px solid ${highlight ? PC.accentBorder : UMR.borderSubtle}` }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 20 }}>
        <Figure label="DJU" value={dju} highlight={highlight} />
        <Figure label="DJClim" value={djclim} highlight={highlight} />
      </div>
      <div style={caption}>{hint}</div>
    </div>
  );
}

/** Degré-jour en saisie, sans unité, avec plage attendue et état d'erreur. */
export function DegreeField({ label, text, valid, range, onChange }: {
  label: string; text: string; valid: boolean; range: string; onChange: (v: string) => void;
}) {
  return (
    <div style={{ width: 150 }}>
      <UMFormGroup label={label}>
        <div style={{ outline: valid ? undefined : `2px solid ${PC.dangerText}` }}>
          <UMInput type="number" min={1} value={text} ariaLabel={label} onChange={onChange} />
        </div>
      </UMFormGroup>
      <div style={{ ...caption, color: valid ? UMR.textSecondary : PC.dangerText }}>
        {valid ? range : `Valeur invalide : ${range}`}
      </div>
    </div>
  );
}

/** Deux champs de degrés-jours côte à côte, groupés comme en lecture. */
export function DegreePairFields({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ display: 'inline-flex', gap: 16, padding: '6px 12px', background: UMR.grey100, border: `1px solid ${UMR.borderSubtle}` }}>
      {children}
    </div>
  );
}
